<template>
  <div class="integralUser">
    <h2 class="f18 fb normal gray_2">自提人信息（{{ identityType === 1 ? "企业" : "个人" }}）</h2>
    <div class="box30"></div>
    <div>
      <div class="flex items-center justify-end">
        <el-button type="primary" @click="updatePickUp('')">添加自提人</el-button>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="name" label="自提人姓名" min-width="20%" />
        <el-table-column show-overflow-tooltip prop="tel" label="手机号" min-width="15%" />
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <span class="red mar20-r" @click="updatePickUp(scope.row)">编辑</span>
            <span class="red" @click="delPickUp(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[30, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addVisible"
      width="500px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="自提人" prop="name">
          <span v-if="ruleForm.id">{{ ruleForm.name }}</span>
          <el-input v-else maxlength="10" v-model.trim="ruleForm.name" placeholder="请输入自提人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="tel">
          <el-input maxlength="11" v-model.trim="ruleForm.tel" placeholder="请输入自提人手机号"></el-input>
        </el-form-item>
        <el-form-item class="text-right mar0-b">
          <el-button @click="resetForm('ruleForm')">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value) {
        const reg = /^1\d{10}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogTitle: "添加自提人",
      identityType: "",

      list: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,

      addVisible: false,
      ruleForm: {
        id: "",
        name: "",
        tel: "",
      },
      rules: {
        name: [{ required: true, message: "请输入自提人姓名", trigger: "blur" }],
        tel: [
          {
            required: true,
            message: "请输入自提人手机号",
            trigger: "blur",
          },
          { validator: checkPhone, trigger: "blur" },
        ],
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const { pageSize, pageNum } = this;
      this.$store
        .dispatch("pickUp/getSelfList", {
          pageSize,
          pageNum,
        })
        .then((data) => {
          console.log("查询自提人列表", data);
          const { list, totalPage, totalCount, identityType } = data;
          console.log(data);
          this.list = list;
          this.totalPage = totalPage;
          this.pageTotal = totalCount;
          this.identityType = identityType;
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    delPickUp(id) {
      this.$confirm("你确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("pickUp/delSelf", {
            id,
          })
          .then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    updatePickUp(item) {
      const { id, tel, name } = item;
      this.ruleForm = {
        id: id || "",
        name: name || "",
        tel: tel || "",
      };
      this.dialogTitle = id ? "编辑自提人" : "新增自提人";
      this.addVisible = true;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("pickUp/updateSelf", this.ruleForm).then((res) => {
            console.log(res);
            if (res.code === "0") {
              const msg = this.ruleForm.id ? "编辑成功！" : "新增成功！";
              this.$message.success(msg);
              this.getList();
              this.resetForm(formName);
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm.id = "";
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
